import { useParams } from 'react-router-dom';
import { StevensTopbar } from '@/components/landing/StevensTopbar';
import { StevensFooter } from '@/components/landing/StevensFooter';
import { DocumentRenderer } from '@/components/legal/DocumentRenderer';
import { CrisisDisclosure } from '@/components/legal/CrisisDisclosure';
import '../landing-v2.css';

// URL slug -> backend document_id. Aliases keep old links working.
const SLUG_TO_DOC: Record<string, string> = {
  terms: 'tos', privacy: 'privacy', ai: 'ai_notice', safety: 'crisis',
  sms: 'sms', email: 'email_marketing', 'helper-code': 'helper_code', 'trfer-aup': 'trfer_aup',
  'community-disclosure': 'community_disclosure',
  'phi-authorization': 'phi_authorization', 'publicity-release': 'publicity_release',
  'data-sharing-website': 'data_sharing_website', 'data-sharing-social-media': 'data_sharing_social_media',
  'data-sharing-newsletter': 'data_sharing_newsletter', 'data-sharing-donor': 'data_sharing_donor',
  'data-sharing-grant-writing': 'data_sharing_grant_writing',
};

export function LegalDocPage() {
  const { doc = 'terms' } = useParams();
  const documentId = SLUG_TO_DOC[doc] ?? doc;
  return (
    <div className="landing-page">
      <StevensTopbar />
      <main className="wrap legal-shell">
        {documentId === 'crisis' && <CrisisDisclosure variant="full" />}
        <DocumentRenderer doc={documentId} />
      </main>
      <StevensFooter />
    </div>
  );
}
